import { api } from '@services';

import {
  UpdateStatusPriority,
  UpdateStatusType,
} from '@models/UpdateStatus.model';
import { IUpdateRawQueryListApiModel } from '@models/Update.model';

interface IChangeUpdate {
  updateStatusId?: string;
  updateId?: string;
  studioId?: string;
  subject?: string;
  description?: string;
  originalMessage?: string;
  productId?: string;
  type?: UpdateStatusType;
  priority?: UpdateStatusPriority;
  assigneeId?: string | null;
}

const changeUpdateStatusByUpdate = async (
  data: IChangeUpdate,
): Promise<IUpdateRawQueryListApiModel> => {
  const { data: update } = await api.patch<IUpdateRawQueryListApiModel>(
    `/updates/updateStatus`,
    data,
  );

  return update;
};

export { changeUpdateStatusByUpdate };
